module.exports = __webpack_public_path__ + "img/orange-ribbon.27dbdd19.svg";